import EntityListManager from './EntityListManager';
import {
  getTaskCategories,
  createTaskCategory,
  updateTaskCategory,
  deleteTaskCategory,
  reorderTaskCategories,
} from '../../services/taskService';

export default function TaskCategoryManager({ onMessage }) {
  return (
    <EntityListManager
      onMessage={onMessage}
      title="Task Categories"
      description="The categories tasks are filed under on the Tasks page. Renaming one renames it on every task."
      entityNoun="Category"
      entityNounPlural="Categories"
      idKey="category_id"
      namePlaceholder="e.g. Accounting, Facilities"
      load={getTaskCategories}
      create={createTaskCategory}
      update={updateTaskCategory}
      remove={deleteTaskCategory}
      reorder={reorderTaskCategories}
      deleteWarning={(item) => `Delete the "${item.name}" category? Tasks in it move to the first category in the list.`}
    />
  );
}
